module.exports = __webpack_public_path__ + "img/rot06.58c5700e.jpg";